import type { OrderFormLine, OrderFormTaxConfig, OrderTotals } from './types';
import { resolveProductTaxInfo } from './orderFormTax';

export function normalizeDiscountPercent(raw: unknown): number {
  const n = Number(raw);
  if (!Number.isFinite(n)) return 0;
  return Math.min(100, Math.max(0, n));
}

export function computeOrderLineSubtotal(
  line: OrderFormLine,
  orderDiscountPercent: unknown = 0
): number {
  const price =
    line.customPrice !== undefined ? line.customPrice : Number(line.price) || 0;
  const quantity = Number(line.selectedQuantity) || 0;
  const lineDiscountFactor = 1 - normalizeDiscountPercent(line.discount) / 100;
  const orderDiscountFactor =
    1 - normalizeDiscountPercent(orderDiscountPercent) / 100;
  return price * quantity * lineDiscountFactor * orderDiscountFactor;
}

export function computeOrderTotals(
  lines: OrderFormLine[],
  options: {
    applyIva: boolean;
    taxConfig: OrderFormTaxConfig;
    orderDiscountPercent?: unknown;
  }
): OrderTotals {
  const orderDiscountPercent = options.orderDiscountPercent ?? 0;
  const subtotal = lines.reduce(
    (acc, line) => acc + computeOrderLineSubtotal(line, orderDiscountPercent),
    0
  );
  const ivaAmount = options.applyIva
    ? lines.reduce((acc, line) => {
        const lineSubtotal = computeOrderLineSubtotal(
          line,
          orderDiscountPercent
        );
        const { taxRate } = resolveProductTaxInfo(line, options.taxConfig);
        return acc + lineSubtotal * (taxRate / 100);
      }, 0)
    : 0;
  return { subtotal, ivaAmount, total: subtotal + ivaAmount };
}
